var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-card",
        { staticClass: "m-0", attrs: { "no-body": "" } },
        [
          _c(
            "b-card-header",
            [
              _c(
                "b-row",
                { attrs: { "align-v": "center" } },
                [
                  _c(
                    "b-col",
                    { staticClass: "mr-auto", attrs: { cols: "auto" } },
                    [
                      _c("h5", { staticClass: "mb-0" }, [
                        _vm._v("Услуги исполнителя")
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { attrs: { cols: "auto" } },
                    [
                      _c(
                        "b-button",
                        {
                          attrs: { size: "sm", variant: "success" },
                          on: {
                            click: function($event) {
                              $event.stopPropagation()
                              return _vm.onAdd()
                            }
                          }
                        },
                        [
                          _c("font-awesome-icon", {
                            staticClass: "mr-1",
                            attrs: { icon: "plus" }
                          }),
                          _vm._v("\n              Добавить\n            ")
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c("b-table", {
            ref: "tw_services",
            staticClass: "mb-0",
            attrs: {
              id: "tw-services",
              selectable: "",
              "select-mode": "single",
              selectedVariant: "success",
              striped: "",
              small: "",
              "thead-class": "top-fixed-thead thead-light",
              "table-class": "text-small",
              responsive: "",
              "show-empty": "",
              "empty-text": _vm.$t("message.common.emptyTable"),
              items: _vm.items,
              fields: _vm.fields,
              "current-page": _vm.currentPage,
              "per-page": _vm.perPage,
              "sort-by": _vm.sortBy,
              "sort-desc": _vm.sortDesc,
              "sort-compare": _vm.sortCompare,
              "no-provider-filtering": "",
              "no-provider-paging": "",
              "no-provider-sorting": ""
            },
            on: {
              "update:sortBy": function($event) {
                _vm.sortBy = $event
              },
              "update:sort-by": function($event) {
                _vm.sortBy = $event
              },
              "update:sortDesc": function($event) {
                _vm.sortDesc = $event
              },
              "update:sort-desc": function($event) {
                _vm.sortDesc = $event
              }
            },
            scopedSlots: _vm._u([
              {
                key: "table-busy",
                fn: function() {
                  return [
                    _c(
                      "div",
                      { staticClass: "text-center text-success my-2" },
                      [
                        _c("b-spinner", { staticClass: "align-middle" }),
                        _vm._v(" "),
                        _c("strong", [_vm._v("Загрузка")])
                      ],
                      1
                    )
                  ]
                },
                proxy: true
              },
              {
                key: "cell(location_work_service_id)",
                fn: function(row) {
                  return [
                    _c("b-form-select", {
                      attrs: {
                        id: "tw_service_id",
                        size: "sm",
                        options: _vm.twsOptions
                      },
                      on: {
                        change: function($event) {
                          return _vm.onServiceSelected(row, $event)
                        }
                      },
                      model: {
                        value: row.item.location_work_service_id,
                        callback: function($$v) {
                          _vm.$set(row.item, "location_work_service_id", $$v)
                        },
                        expression: "row.item.location_work_service_id"
                      }
                    })
                  ]
                }
              },
              {
                key: "cell(quantity)",
                fn: function(row) {
                  return [
                    _c("b-form-input", {
                      attrs: {
                        id: "tw_quantity",
                        size: "sm",
                        autocomplete: "off"
                      },
                      on: {
                        input: function($event) {
                          return _vm.calculateServiceTotal(row.item)
                        }
                      },
                      model: {
                        value: row.item.quantity,
                        callback: function($$v) {
                          _vm.$set(row.item, "quantity", _vm._n($$v))
                        },
                        expression: "row.item.quantity"
                      }
                    })
                  ]
                }
              },
              {
                key: "cell(price)",
                fn: function(row) {
                  return [
                    _c("b-form-input", {
                      attrs: {
                        id: "tw_price",
                        size: "sm",
                        autocomplete: "off",
                        disabled: true
                      },
                      model: {
                        value: row.item.price,
                        callback: function($$v) {
                          _vm.$set(row.item, "price", _vm._n($$v))
                        },
                        expression: "row.item.price"
                      }
                    })
                  ]
                }
              },
              {
                key: "cell(unit)",
                fn: function(row) {
                  return [
                    _c("unit-select", {
                      key: row.item.unit_code + "-" + row.index,
                      ref: "unit_select",
                      attrs: {
                        id: "tw_unit",
                        "initial-unit": row.item.unit_code,
                        "is-short": "",
                        "is-disabled": true
                      },
                      on: {
                        selectUnit: function($event) {
                          return _vm.updateUnit($event, row)
                        }
                      }
                    })
                  ]
                }
              },
              {
                key: "cell(total_price)",
                fn: function(row) {
                  return [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.priceFormat(row.item.total_price)) +
                        "\n        "
                    )
                  ]
                }
              },
              {
                key: "cell(action)",
                fn: function(row) {
                  return [
                    _c(
                      "b-button",
                      {
                        attrs: { size: "sm", variant: "danger" },
                        on: {
                          click: function($event) {
                            return _vm.onRemove(row)
                          }
                        }
                      },
                      [_c("font-awesome-icon", { attrs: { icon: "trash" } })],
                      1
                    )
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c(
            "b-card-footer",
            { attrs: { "footer-bg-variant": "light" } },
            [
              _c(
                "b-row",
                { attrs: { "align-h": "between", "align-v": "center" } },
                [
                  _c(
                    "b-col",
                    { staticClass: "mr-2", attrs: { cols: "auto" } },
                    [
                      _vm._v("\n            Всего записей: "),
                      _c("b", [_vm._v(_vm._s(_vm.items.length))])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { staticClass: "mr-auto", attrs: { cols: "auto" } },
                    [
                      _c(
                        "span",
                        {
                          class: {
                            "text-danger font-weight-bold": _vm.isMismatch
                          },
                          attrs: { id: "total-sum-" + _vm.tw.id }
                        },
                        [
                          _vm._v("\n            Общая сумма: "),
                          _c("b", [
                            _vm._v(_vm._s(_vm.priceFormat(_vm.totalSum)))
                          ])
                        ]
                      ),
                      _vm._v(" "),
                      _vm.isMismatch
                        ? _c(
                            "b-tooltip",
                            {
                              attrs: {
                                target: "total-sum-" + _vm.tw.id,
                                variant: "danger"
                              }
                            },
                            [
                              _vm._v(
                                "\n              Сумма услуг исполнителя не совпадает с итого (" +
                                  _vm._s(_vm.priceFormat(_vm.tw.total_price)) +
                                  ").\n            "
                              )
                            ]
                          )
                        : _vm._e()
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { attrs: { cols: "auto" } },
                    [
                      _c("b-pagination", {
                        attrs: {
                          id: "tw-services-pagination",
                          pills: "",
                          "total-rows": _vm.items.length,
                          "per-page": _vm.perPage
                        },
                        model: {
                          value: _vm.currentPage,
                          callback: function($$v) {
                            _vm.currentPage = $$v
                          },
                          expression: "currentPage"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-670baa52", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-670baa52","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Tasks/TaskWorkerServices.vue
// module id = null
// module chunks = 